<template lang="html">
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <StandardDeleteBtn :el="on" @deleteClick="deleteActivator()" />
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Delete Community Sequence</span>
      </v-card-title>
      <v-card-text>
        Are you sure you want to delete this Community Sequence?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="deleteCommunitySequence({csequence_id: csequence_id})">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
import { mapActions } from 'vuex';
export default {
  name: 'CommunityDeleteCSequenceDialog',
  components: {
    StandardDeleteBtn
  },
  props: ['csequence_id'],
  data: () => ({
    dialog: false
  }),
  methods: {
    ...mapActions('Community', [
      'deleteCommunitySequence'
    ]),
    deleteActivator(){
      this.dialog = true;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
